import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {nextTick, onBeforeMount, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";

// const routerViewContainer = ref<HTMLElement | null>(null);
//
// const isWechat = () => {
//   return (String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === "micromessenger");
// };


// const route = useRoute()

// watch(() => route.name, (newValue, oldValue) => {
//   if (oldValue && newValue !== oldValue && newValue === "Index" && isWechat()) {
//     window.location.reload()
//   }
// })


// onBeforeMount(() => {
//   if (
//       !location.hostname.includes('127') &&
//       !location.hostname.includes('localhost')
//   ) {
//     ;(() => {
//       const block = () => {
//         setInterval(() => {
//           ;(function () {
//             return false
//           })
//               ['constructor']('debugger')
//               ['call']()
//         }, 50)
//       }
//       try {
//         if (location.hostname === 'vue-admin-beautiful.com' || location.hostname === 'chu1204505056.gitee.io')
//           console.error('演示地址禁止调试，如需调试代码请联系客服购买！')
//         block()
//       } catch {
//         /* empty */
//       }
//     })()
//   }
// })


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})